import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { TooltipProvider } from "./components/ui/tooltip";
import { installStaleChunkGuard } from "./lib/stale-chunk-guard";
import {
  applyPlatformFlags,
  registerServiceWorker,
  watchInstallPrompt,
} from "./lib/pwa";
import "./index.css";

// Recupera i lazy-load falliti dalle schede aperte durante un deploy
installStaleChunkGuard();
// PWA: worker per l'apertura offline della shell + evento di installabilità
registerServiceWorker();
watchInstallPrompt();
applyPlatformFlags();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider delayDuration={150}>
            <App />
            {/* Toast sui token del tema (prima era navy hardcoded) e sotto la
                tacca su mobile: la posizione la governa la classe. */}
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={{
                className:
                  "!bg-card !text-foreground !border !border-primary/20 !shadow-renaissance",
              }}
              style={{ top: "calc(env(safe-area-inset-top) + 0.75rem)" }}
            />
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
